import {Box, HStack, Text} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {useTenant} from '@dms/shared';

import {EMPTY_PLACEHOLDER, Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {CURRENCY_DECIMALS} from '../../../../../constants/CURRENCY_DECIMALS';

interface PriceWithAndWithoutVatProps extends RequiredTestIdProps {
  withoutVat: number | Nullish;
  withVat: number | Nullish;
  isBold?: boolean;
}

export function PriceWithAndWithoutVat(props: PriceWithAndWithoutVatProps) {
  const tenant = useTenant();
  const formatCurrency = useFormatCurrency();

  const formatPrice = (price: number | Nullish, suffix: string) => {
    if (isNil(price)) {
      return EMPTY_PLACEHOLDER;
    }
    return `${formatCurrency(price, tenant.tenantCurrency, CURRENCY_DECIMALS)} ${suffix}`;
  };

  return (
    <HStack spacing={4}>
      <Box flex={1}>
        <Text
          size="xSmall"
          alternative={props.isBold}
          data-testid={suffixTestId('withoutVat', props)}
        >
          {formatPrice(props.withoutVat, i18n.t('general.labels.withoutVat'))}
        </Text>
      </Box>
      <Box flex={1}>
        <Text size="xSmall" alternative={props.isBold} data-testid={suffixTestId('withVat', props)}>
          {formatPrice(props.withVat, i18n.t('general.labels.withVat'))}
        </Text>
      </Box>
    </HStack>
  );
}
